// @flow

import React from 'react';
import { Field } from 'redux-form';
import { withRequired } from '../../validators';
import { ReduxFormLabeledCheckbox } from '../../../form/labeledFields';
import { Flex } from '../../../grid';
import { breakpointsToArray } from '../../../../helpers';
import { Text } from '../../../form/labelText';
import FormRow from '../../../form/formRow';

type OwnProps = {
  label: string,
  name: string,
  options: Array<{|
    label: string,
    value: string,
  |}>,
  showLabel: boolean,
  validate?: Array<Function>,
};

type Props = OwnProps;

const CheckboxField = ({
  name,
  label,
  options,
  validate,
  showLabel,
}: Props) => (
  <FormRow>
    <Flex
      flexWrap={breakpointsToArray({ default: 'wrap', sm: 'nowrap' })}
      flexGrow="1"
      flexBasis="100%"
    >
      {showLabel && (
        <Flex width={breakpointsToArray({ default: 1, md: 6 / 12 })} flexShrink={0} pb="0.5em">
          <Text>{label}</Text>
        </Flex>
      )}
      <Flex flexDirection="column" width={showLabel ? breakpointsToArray({ default: 1, md: 8 / 12 }) : 1}>
        {options.map((option, index) => (
          <Field
            key={`${name}${option.label}`}
            name={`${name}${index > 0 ? ` - ${option.value}` : ''}`}
            component={ReduxFormLabeledCheckbox}
            label={option.value}
            type="checkbox"
            value={option.label}
            validate={validate}
          />
        ))}
      </Flex>
    </Flex>
  </FormRow>
);

CheckboxField.defaultProps = {
  placeholder: '',
  validate: [],
};

export default withRequired<Props>(CheckboxField);
